export const preserveDisplayOrder = (value: string | undefined, locale: string): string => {
    if (!value) return ''
    if (locale !== 'ar') return value
    return `\u2066${value}\u2069`
}

export default preserveDisplayOrder
